import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useChangeMitarbeiterBeiAuftragMutation, useGetManagerProfileAuftraegeListeMutation, useGetManagerProfileListeMutation } from '../../../api/ManagerAPI';
import { LoadingModal } from '../../../component/LoadingModal/LoadingModal';
import { IManagerProfile, IManagerProfileAuftragResponseDto } from '../../../types/Types';
import { formatToEuroDate } from '../../../util/DateUtils';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../manager.module.scss';
import Footer from '../../footer/Footer';

type listecheck = {
  checked: boolean;
  satz: IManagerProfileAuftragResponseDto;
}

export default function ManagerProfileAuftraege() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [getListeProfileAPI] = useGetManagerProfileListeMutation();
  const [getListeApi] = useGetManagerProfileAuftraegeListeMutation();
  const [changeMitarbeiterBeiAuftragApi] = useChangeMitarbeiterBeiAuftragMutation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<listecheck[]>();
  const [listeProfile, setListeProfile] = useState<IManagerProfile[]>([]);
  const [changeProfile, setChangeProfile] = useState<IManagerProfile>();
  const [aktuellesProfil, setAktuellesProfil] = useState<IManagerProfile>();

  const ladeliste = () => {
    setLoaded(false);
    getListeApi(location.state.id)
      .unwrap()
      .then((e) => setListe(e.map(ee => ({
        checked: false,
        satz: ee
      }))))
      .catch((ee) => console.log(ee))
      .finally(() => setLoaded(true));
  }

  const ladeListeMitarbeiter = () => {
    getListeProfileAPI()
      .unwrap()
      .then((e) => setListeProfile(e.filter(ee => ee.uid !== location.state.id)))
      .catch((ee) => console.log(ee));
  }

  const ladeProfil = () => {
    getListeProfileAPI()
      .unwrap()
      .then((e) => setAktuellesProfil(e.find(ee => ee.uid === location.state.id)))
      .catch((ee) => console.log(ee));
  }

  const init = () => {
    ladeProfil();
    ladeliste();
  }

  const changeCheckbox = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const checked = e.target.checked;
    setListe(liste?.map((eem, i) => (
      i === index ? {
        ...eem,
        checked: checked
      } : eem)));
  }

  const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    var x = listeProfile.find(ee => ee.uid === e.target.value);
    setChangeProfile(x);
  }

  const verschieben = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    console.log("Verschieben zu " + changeProfile?.name);
    setLoaded(true);
    changeMitarbeiterBeiAuftragApi({
      uid_profile: changeProfile?.uid!,
      uid_auftraege: liste?.filter(ee => ee.checked).map(ee => ee.satz.uid)!
    }).unwrap()
      .finally(() => {
        setLoaded(false);
        ladeliste();
      });

  }

  useEffect(() => {
    ladeListeMitarbeiter();
  }, [aktuellesProfil]);

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Profile Aufträge für {aktuellesProfil?.name}</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <form onSubmit={verschieben}>
            Markierte Aufträge an folgenden Mitarbeiter verschieben:
            <select onChange={changeitselect} value={"" + changeProfile?.uid}>
              <option value={""}>-- Bitte auswählen --</option>
              {listeProfile.map((p) => <option key={p.uid} value={p.uid} selected={(p.uid === changeProfile?.uid) ? true : false}>{p.name}</option>)}
            </select>
            <button type="submit" className="btn btn-primary" >Zuordnen</button>
          </form>

          <table className="table table-striped">

              <thead>
                <tr>
                  <th>Option<i style={{ marginLeft: "10px" }} /></th>
                  <th>Art<i style={{ marginLeft: "10px" }} /></th>
                  <th>Status <i style={{ marginLeft: "10px" }} /></th>
                  <th>Auftragsnr. <i style={{ marginLeft: "10px" }} /></th>
                  <th>Name <i style={{ marginLeft: "10px" }} /></th>
                  <th>Lieferort <i style={{ marginLeft: "10px" }} /></th>
                  <th>Termin <i style={{ marginLeft: "10px" }} /></th>
                  <th>Erstellt am</th>
                </tr>
              </thead>
              <tbody>
          {
            (liste?.map((e, index) =>
              <tr key={index}>
                <td style={{ textAlign: "center" }}><input type="checkbox" checked={e.checked} onChange={(ev) => changeCheckbox(ev, index)} /></td>
                <td>{e.satz.art}</td>
                <td>{e.satz.status}</td>
                <td>{e.satz.auftragsnr_ag}</td>
                <td>{e.satz.vorname_endkunde + ' ' + e.satz.name_endkunde}</td> 
                <td>{e.satz.ort_lieferadresse}</td>
                <td>{formatToEuroDate(e.satz.aktuellerTermin)}</td>
                <td>{formatToEuroDate(e.satz.erstelltAm)}</td>
              </tr>)
            )
          }
              </tbody>
          </table>
        </div>

        <LoadingModal show={!isLoaded} text={"Lade..."} />
      </div >

      <Footer />

    </>
  );
}